import React from 'react'
import { OrgInvitationStatus } from 'pure-js/types/OrgInvitation'

import { SegmentTabBar } from '../../../../interaxDesignSystemComponents'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { orgInviteStatusTranslationKey } from '../../orgTranslationKeys'

const INVITE_TABS: OrgInvitationStatus[] = [
  OrgInvitationStatus.PENDING,
  OrgInvitationStatus.ACCEPTED,
  OrgInvitationStatus.EXPIRED,
  OrgInvitationStatus.REVOKED
]

interface OrgInvitesStatusTabsProps {
  value: OrgInvitationStatus
  onChange: (status: OrgInvitationStatus) => void
  counts: Record<OrgInvitationStatus, number>
}

export const OrgInvitesStatusTabs: React.FC<OrgInvitesStatusTabsProps> = ({ value, onChange, counts }) => {
  const { t } = useTranslation()

  return (
    <SegmentTabBar
      variant="underline"
      ariaLabel={t('org.invites.statusTabsAria')}
      value={value}
      onChange={(next) => onChange(next as OrgInvitationStatus)}
      tabs={INVITE_TABS.map((status) => ({
        value: status,
        label: t(orgInviteStatusTranslationKey(status)),
        badge: counts[status]
      }))}
    />
  )
}
